import Queue from './queue.js'

class DialogManager {
  constructor () {
    this.queue = new Queue()
  }
  popup (elemnt) {
    this.queue.push(elemnt)
  }
}
export default DialogManager


